import React, { useEffect, useState } from "react";
import { Checkbox } from "antd";

import Style from "../questionItem.module.scss";
import { getDuoxuanSelectIdList } from "../../../utils/filter";

interface IProps {
    homeworkState: number;
    list: {
        answerId: number;
        content: string;
        isChoose: "0" | "1";
        isRight: "0" | "1";
    }[];
    onChange: (value: number[]) => void;
}

export const Multiple = ({ list, homeworkState, onChange }: IProps) => {
    let [values, setValues] = useState<number[]>(getDuoxuanSelectIdList(list));

    const handleChange = (values: any[]) => {
        if (homeworkState === 2) return;
        onChange(values);
    };

    useEffect(() => {
        setValues(getDuoxuanSelectIdList(list));
    }, [list]);

    return (
        <Checkbox.Group onChange={handleChange} value={values}>
            {list.map(item => (
                <div key={item.answerId} className={Style.option}>
                    <Checkbox
                        className={
                            homeworkState === 2 && item.isRight === "1"
                                ? Style.success
                                : undefined
                        }
                        value={item.answerId}>
                        <div
                            dangerouslySetInnerHTML={{ __html: item.content }}
                            className={Style.richText}
                        />
                    </Checkbox>
                </div>
            ))}
        </Checkbox.Group>
    );
};
